import { englishType } from 'types'

export const lesson26: englishType[] = [
  {
    id: 1,
    word: 'address',
    meaning: ['다루다', '처리하다'],
  },
  {
    id: 2,
    word: 'apply',
    meaning: ['지원하다', '신청하다'],
  },
  {
    id: 3,
    word: 'arrest',
    meaning: ['체포하다'],
  },
  {
    id: 4,
    word: 'artificial',
    meaning: ['인공적인'],
  },
  {
    id: 5,
    word: 'commit',
    meaning: ['범죄를 저지르다'],
  },
  {
    id: 6,
    word: 'connect',
    meaning: ['연결하다'],
  },
  {
    id: 7,
    word: 'destroy',
    meaning: ['파괴하다'],
  },
  {
    id: 8,
    word: 'detective',
    meaning: ['형사', '수사관'],
  },
  {
    id: 9,
    word: 'distort',
    meaning: ['왜곡하다', '비틀다'],
  },
  {
    id: 10,
    word: 'ensure',
    meaning: ['확실히 하다', '보장하다'],
  },
  {
    id: 11,
    word: 'evolve',
    meaning: ['진화하다', '발전하다'],
  },
  {
    id: 12,
    word: 'frightened',
    meaning: ['무서워하는'],
  },
  {
    id: 13,
    word: 'headquarters',
    meaning: ['본사', '본부'],
  },
  {
    id: 14,
    word: 'implant',
    meaning: ['이식하다', '심다'],
  },
  {
    id: 15,
    word: 'investigate',
    meaning: ['조사하다'],
  },
  {
    id: 16,
    word: 'manipulate',
    meaning: ['조종하다', '조작하다'],
  },
  {
    id: 17,
    word: 'override',
    meaning: ['무시하다'],
  },
  {
    id: 18,
    word: 'pliable',
    meaning: ['유연한'],
  },
  {
    id: 19,
    word: 'release',
    meaning: ['출시하다', '발매하다', '개봉하다', '석방하다'],
  },
  {
    id: 20,
    word: 'simulate',
    meaning: ['모의실험하다', '흉내내다'],
  },
  {
    id: 21,
    word: 'leap',
    meaning: ['도약', '급등'],
  },
  {
    id: 22,
    word: 'frontier',
    meaning: ['미개척지', '국경'],
  },
]
